import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export type FtpConnectionValues = {
  host: string;
  username: string;
  password: string;
  path: string;
  processedPath: string;
  filter: string;
  excludeFilter: string;
};

type FtpConfigFieldsProps = {
  values: FtpConnectionValues;
  onChange: (field: keyof FtpConnectionValues, value: string) => void;
  disabled?: boolean;
};

export function FtpConfigFields({
  values,
  onChange,
  disabled,
}: FtpConfigFieldsProps) {
  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <Label htmlFor="ftp-host">
          Host <span className="text-red-500 text-xs font-semibold">*</span>
        </Label>
        <Input
          id="ftp-host"
          placeholder="Host"
          value={values.host}
          onChange={(e) => onChange("host", e.target.value)}
          disabled={disabled}
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="ftp-username">
          Username <span className="text-red-500 text-xs font-semibold">*</span>
        </Label>
        <Input
          id="ftp-username"
          placeholder="Username"
          value={values.username}
          onChange={(e) => onChange("username", e.target.value)}
          disabled={disabled}
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="ftp-password">
          Password <span className="text-red-500 text-xs font-semibold">*</span>
        </Label>
        <Input
          id="ftp-password"
          type="password"
          placeholder="Password"
          value={values.password}
          onChange={(e) => onChange("password", e.target.value)}
          disabled={disabled}
          autoComplete="off"
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="ftp-path">
          Path <span className="text-red-500 text-xs font-semibold">*</span>
        </Label>
        <Input
          id="ftp-path"
          placeholder="Path"
          value={values.path}
          onChange={(e) => onChange("path", e.target.value)}
          disabled={disabled}
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="ftp-processedPath">Processed Path</Label>
        <Input
          id="ftp-processedPath"
          placeholder="Processed Path"
          value={values.processedPath}
          onChange={(e) => onChange("processedPath", e.target.value)}
          disabled={disabled}
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="ftp-filter">Filter</Label>
        <Input
          id="ftp-filter"
          placeholder="Filter"
          value={values.filter}
          onChange={(e) => onChange("filter", e.target.value)}
          disabled={disabled}
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="ftp-excludeFilter">Exclude Filter</Label>
        <Input
          id="ftp-excludeFilter"
          placeholder="Exclude Filter"
          value={values.excludeFilter}
          onChange={(e) => onChange("excludeFilter", e.target.value)}
          disabled={disabled}
        />
      </div>
    </div>
  );
}
